import { ProductsSummaryTypes } from './types';

export const colors: Record<ProductsSummaryTypes, string> = {
  sold: '#1395AE',
};
